module.exports = __webpack_public_path__ + "img/8a840c090c221efd6ec7bf0634c9159f.816f7b1e.jpg";